export const SELECTORS = {
  CONTAINER: 'js-referral-bar',
  CLOSE_BTN: 'js-referral-bar-close',
  NAME: 'js-referral-bar-name'
};

export const REFERRAL_LINK_INFO_GLOBAL = 'referralLinkInfo';

export const REFERRAL_TOKEN_COOKIE_EXPIRY_DAYS = 30;

export const REFERRAL_CHECKOUT_VALIDATION_TIMEOUT_MS = 3000;
